import { type ISpecSections, SECTIONS } from '../../spec/SpecSections';
import type { Field } from '../Field';
import { SectionType } from './SectionType';

/**
 * Class for managing FIX field sections.
 * Provides functionality to process and organize FIX fields into their respective sections.
 */
export class Sections {
    /** Array of all available section specifications */
    public sections: ISpecSections[] = SECTIONS;
    /** Cache map for looking up sections by ID */
    public cacheMap: Map<string, ISpecSections> = new Map<string, ISpecSections>();
    /** Instance of SectionType for managing section data */
    public sectionType: SectionType = new SectionType();

    /**
     * Creates a new Sections instance and initializes the cache map
     * with all available section specifications.
     */
    constructor() {
        this.sections.forEach((section) => {
            this.cacheMap.set(section.SectionID, section);
        });
    }

    /**
     * Processes a field's section based on its section ID.
     * Sets the appropriate section type for the field if found.
     *
     * @param {Field} item - The field to process
     * @param {string} sectionId - The section ID to look up
     */
    public processSection(item: Field, sectionId: string): void {
        this.sectionType.reset();
        const sectionData: ISpecSections | undefined = this.cacheMap.get(sectionId);
        if (sectionData) {
            this.sectionType.setSection(sectionData);
            item.setSection(this.sectionType);
        }
    }
}
